import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "cookie-consent-banner",
  class: "cookie-consent"
}
const _hoisted_2 = { class: "cookie-consent__content" }
const _hoisted_3 = { class: "cookie-consent__text" }
const _hoisted_4 = { class: "cookie-consent__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.cookiesDescription) + " ", 1),
          _cache[3] || (_cache[3] = _createElementVNode("a", {
            href: "https://vaultn.com/cookie-notice/",
            class: "cookie-consent__notice-link",
            target: "_blank",
            rel: "noopener noreferrer"
          }, " Read our Cookie Notice ", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          id: "cookie-accept-all",
          class: "cookie-consent__button cookie-consent__button--primary",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('accept-all')))
        }, " Accept All "),
        _createElementVNode("button", {
          id: "cookie-accept-essential",
          class: "cookie-consent__button cookie-consent__button--secondary",
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('accept-essential')))
        }, " Essential Only "),
        _createElementVNode("button", {
          id: "cookie-settings",
          class: "cookie-consent__button cookie-consent__button--tertiary",
          type: "button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('navigate-settings')))
        }, " Cookie Settings ")
      ])
    ])
  ]))
}